import { useState } from "react";

type UseCursorPaginationOptions = {
  defaultPage?: number;
};

export function useCursorPagination({ defaultPage = 1 }: UseCursorPaginationOptions = {}) {
  const [currentPage, setCurrentPage] = useState(defaultPage);
  // cursors[i] = start_key needed to fetch page i+1; cursors[0] = undefined (first page)
  const [cursors, setCursors] = useState<(string | undefined)[]>([undefined]);

  // highest page reachable = last page with a known cursor + 1
  const maxNavigablePage = cursors.length;

  const currentStartKey = cursors[currentPage - 1];

  function onPageChange(page: number) {
    setCurrentPage(page);
  }

  // call after receiving a response to cache the cursor for the next page
  function registerNextCursor(page: number, nextKey: string | null | undefined) {
    if (!nextKey) return;
    setCursors((prev) => {
      if (prev[page]) return prev; // already cached
      const next = [...prev];

      next[page] = nextKey;

      return next;
    });
  }

  function resetPage() {
    setCurrentPage(defaultPage);
    setCursors([undefined]);
  }

  return {
    currentPage,
    currentStartKey,
    maxNavigablePage,
    onPageChange,
    registerNextCursor,
    resetPage,
  };
}
